import { Injectable } from '@angular/core';
import { AppConstants } from '../../constants/app.constants';
import { environment } from '../../../environments/environment.prod';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ContactModel } from '../../models/contact.model';
import { StateModel } from '../../models/user.model';
import { Observable } from 'rxjs';

@Injectable()
export class ContactService {

  controller: string = 'Contact/';
  baseUrl: string = AppConstants.accessBaseUrl;
  API_KEY = environment.secreteKey;
  private readonly headers = new HttpHeaders({ 'x-api-key': this.API_KEY, 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private readonly http: HttpClient) { }

  getStates(countryId: string): Observable<StateModel[]> {
    let params = new HttpParams().set('countryId', countryId);
    return this.http.get<StateModel[]>(this.baseUrl + 'Address/' + AppConstants.getStates, {...this.options, params});
  }

  getCities(stateId: string, countryId: string): Observable<[string]> {
    let params = new HttpParams().set('stateId', stateId).set('countryId', countryId);
    return this.http.get<[string]>(this.baseUrl + 'Address/' + AppConstants.getCities, { ...this.options, params });
  }

  saveContactInfo(contactModel: ContactModel) {
    return this.http.post(this.baseUrl + this.controller + AppConstants.saveContactInfo, JSON.stringify(contactModel), this.options);
  }

  saveNewsletterInfo(email: string): Observable<string> {
    let params = new HttpParams().set('email', email);
    return this.http.post<string>(this.baseUrl + this.controller + AppConstants.saveNewsletterInfo, { ...this.options, params });
  }

}
